import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
export const timelineSortOptions = [
    {
        direction: 'descending',
        key: 'date',
        label: COPY_SPECIFIC.DETECTED_DATE
    },
    {
        direction: 'ascending',
        key: 'modifiedBy',
        label: COPY_SPECIFIC.MODIFIED_BY
    }
];
